import { Box, SpaceBetween } from '@amzn/awsui-components-core';
import React from 'react';
import {
  ContentEngagement,
  ContentEngagementType,
} from '@amzn/awscat-pattern-library-service-model';
import ContentEngagementItem from './ContentEngagementItem';

interface ContentEngagementListProps {
  engagements: Array<ContentEngagement & ContentEngagementDisplayProps>;
  onItemDelete?: (engagementIndex: number) => void;
  onItemUpdate?: (
    engagementIndex: number,
    engagementUpdateProps: ContentEngagementUpdateProps,
  ) => void;
}

export interface ContentEngagementUpdateProps {
  salesforceId: string;
  notes: string;
  engagementType: ContentEngagementType;
  validationError?: string;
}

export interface ContentEngagementDisplayProps {
  key: string;
  salesforceIdError: string;
}

export const ContentEngagementList: React.FunctionComponent<ContentEngagementListProps> = (
  props: ContentEngagementListProps,
) => {
  const { engagements, onItemDelete, onItemUpdate } = props;

  const getEngagementItem = (
    index: number,
    engagement: ContentEngagement & ContentEngagementDisplayProps,
  ) => {
    return (
      <ContentEngagementItem
        engagementIndex={index}
        key={engagement.key}
        engagementType={engagement.engagementType || ContentEngagementType.Project}
        notes={engagement.notes}
        onItemUpdate={onItemUpdate}
        onItemDelete={onItemDelete}
        salesforceId={engagement.salesforceId}
        salesforceIdError={engagement.salesforceIdError}
      />
    );
  };

  const renderEngagementItems = () => {
    return engagements.map((engagement, index) => getEngagementItem(index, engagement));
  };

  return (
    <Box padding={{ top: 'xs' }}>
      <SpaceBetween direction="vertical" size="xs">
        {renderEngagementItems()}
      </SpaceBetween>
    </Box>
  );
};
